import React, { useState } from 'react';

const packages = [
  {
    name: 'Başlangıç',
    price: '₺990',
    oldPrice: '₺1.490',
    discount: '33% İNDİRİM',
    desc: 'Küçük işletmeler ve yeni başlayanlar için temel özellikler.',
    features: [
      '1 pano',
      'Gerçek zamanlı veri takibi',
      'Temel raporlama',
      'E-posta desteği',
    ],
    highlight: false,
  },
  {
    name: 'Profesyonel',
    price: '₺2.490',
    oldPrice: '₺3.690',
    discount: '33% İNDİRİM',
    desc: 'Büyüyen işletmeler için gelişmiş özellikler.',
    features: [
      '5 pano',
      'Gelişmiş veri analitiği',
      'Alarm yönetimi',
      'Öncelikli destek',
    ],
    highlight: false,
  },
  {
    name: 'Kurumsal',
    price: '₺4.990',
    oldPrice: '₺7.490',
    discount: '33% İNDİRİM',
    desc: 'Büyük ölçekli işletmeler ve fabrikalar için tam kapsamlı çözüm.',
    features: [
      'Sınırsız pano',
      'Yapay zeka destekli analiz',
      'Kapsamlı raporlama',
      '7/24 VIP destek',
    ],
    highlight: false,
  },
];

export default function PricingPackages() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
      {packages.map((pkg, i) => {
        const isSelected = selected === i;
        return (
          <div
            key={i}
            onClick={() => setSelected(i)}
            className={`relative rounded-2xl shadow-lg p-14 flex flex-col items-center text-center border-4 cursor-pointer transition-all duration-200
              ${isSelected
                ? 'z-20 scale-105 border-[var(--color-secondary)] bg-white shadow-2xl'
                : pkg.highlight
                  ? 'border-[var(--color-secondary)] bg-white'
                  : 'border-gray-200 bg-white'}
              ${isSelected ? '' : 'hover:scale-105 hover:z-10'}
            `}
            style={{ boxShadow: isSelected ? '0 8px 32px 0 rgba(70,184,127,0.18)' : undefined }}
          >
            {/* İndirim etiketi */}
            <div className="absolute top-0 right-0">
              <span className="inline-block bg-[var(--color-secondary)] text-white text-xs font-bold px-3 py-1 rounded-bl-2xl rounded-tr-lg shadow-md" style={{transform: 'translateY(-50%) translateX(30%)'}}>
                {pkg.discount}
              </span>
            </div>
            <h2 className="text-2xl font-bold mb-2 text-[var(--color-primary)]">{pkg.name}</h2>
            <div className="flex flex-col items-center mb-2">
              <span className="text-gray-400 line-through text-lg">{pkg.oldPrice}</span>
              <span className="text-4xl font-extrabold text-[var(--color-secondary)]">{pkg.price}</span>
            </div>
            <p className="mb-4 text-[var(--color-black)]">{pkg.desc}</p>
            <ul className="mb-6 text-left w-full max-w-xs mx-auto">
              {pkg.features.map((f, j) => (
                <li key={j} className="flex items-center gap-2 mb-2 text-[var(--color-primary)]">
                  <span className="inline-block w-2 h-2 rounded-full bg-[var(--color-secondary)]"></span>
                  {f}
                </li>
              ))}
            </ul>
            <button
              className={`w-full py-3 rounded-lg font-semibold text-lg transition
                ${isSelected
                  ? 'bg-[var(--color-secondary)] text-white hover:bg-[var(--color-primary)]'
                  : pkg.highlight
                    ? 'bg-[var(--color-secondary)] text-white hover:bg-[var(--color-primary)]'
                    : 'bg-[var(--color-primary)] text-white hover:bg-[var(--color-secondary)]'}`}
            >
              Başvur
            </button>
          </div>
        );
      })}
    </div>
  );
} 